import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCentroCostoVentaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCentroCostoVenta'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagCentroCostoVenta'
          label='Centro Costo en Venta'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagCentroCostoVentaFormGroup)
